import classNames from 'classnames/bind'

import generalStyles from '../../CandidateDetailsContainer.module.scss'
import reviewStyles from '../../candidateReviewsCard/candidateReview/CandidateReview.module.scss'
import { formatUtcDate, calculateScoreTone, calculateWeightedMaxScore, formatScoreValue } from '../../../utils/utils'

import { goodstackPalette } from '@percent/partner-dashboard/app/theme/Theme'
import { Group, Flex, Text } from '@percent/lemonade'
import { InlineAccordionAnswerProps } from './InlineAccordionAnswer.types'

const cx = classNames.bind(reviewStyles)

export function InlineAccordionAnswer({ label, answer, type, decision, score }: Readonly<InlineAccordionAnswerProps>) {
  const renderAnswer = () => {
    switch (type) {
      case 'score': {
        const weightedMax = calculateWeightedMaxScore(score!)
        const tone = calculateScoreTone(Number(answer) / weightedMax)

        return (
          <Flex className={cx(reviewStyles.scoreCtn, reviewStyles[`score${tone}`])}>
            {formatScoreValue(Number(answer))} / {formatScoreValue(weightedMax)}
          </Flex>
        )
      }
      case 'decision':
        return <Flex className={cx(reviewStyles.decisionCtn, reviewStyles[String(decision)])}>{answer}</Flex>
      case 'date':
      case 'scheduled_event':
      case 'payment_date':
        return <Flex> {formatUtcDate(answer)}</Flex>
      default:
        return <Flex>{answer}</Flex>
    }
  }

  return (
    <div className={cx(generalStyles.innerCardSection, generalStyles.defaultTopBorder)}>
      <Group className={reviewStyles.group}>
        <div>
          <Text fontWeight="medium" size="small" color={goodstackPalette.black}>
            {label}
          </Text>
        </div>
        <div>{renderAnswer()}</div>
      </Group>
    </div>
  )
}
